import { EnvironmentBase } from './environment.base';
export const environment = EnvironmentBase;
